import { render } from "./EditarEmpresa.vue?vue&type=template&id=13ed2f25"
import script from "./EditarEmpresa.vue?vue&type=script&lang=js"
export * from "./EditarEmpresa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__